import React, { useState } from 'react';

const CreateSessionDialog = ({ isOpen, onClose, onConfirm }) => {
  const [name, setName] = useState(`新对话 ${new Date().toLocaleString()}`);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onConfirm(name);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content create-session-modal">
        <h2>创建新对话</h2>
        <form onSubmit={handleSubmit}>
          <div className="modal-form-group">
            <label>对话名称:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="请输入对话名称"
              autoFocus
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="confirm-btn">
              创建
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateSessionDialog; 